export const QUESTIONS = [
  {
    id: "documentation",
    q: "Do you have dated photo or video documentation of your property's current condition?",
    weight: 20,
    area: "Pre-loss condition documentation",
    step: "Commission a pre-loss condition report with time-stamped photography before the next storm season.",
  },
  {
    id: "policy",
    q: "Have you reviewed your insurance policy coverage, exclusions, and deductibles in the last 12 months?",
    weight: 15,
    area: "Policy & coverage awareness",
    step: "Schedule a policy review to map exclusions, deductibles, and coverage gaps against your real exposure.",
  },
  {
    id: "inspection",
    q: "Has your roof, building envelope, or major systems been professionally inspected in the last 2 years?",
    weight: 20,
    area: "Physical condition & maintenance",
    step: "Arrange a field inspection of the roof, envelope, and mechanical systems to establish a defensible baseline.",
  },
  {
    id: "plan",
    q: "Do you have a written plan for the first 72 hours after a loss?",
    weight: 15,
    area: "Loss response readiness",
    step: "Create a 72-hour response plan covering mitigation, notice deadlines, and who to call first.",
  },
  {
    id: "records",
    q: "Are your key records (permits, receipts, warranties, appraisals) stored securely off-site or in the cloud?",
    weight: 15,
    area: "Records & evidence security",
    step: "Digitize and secure permits, receipts, appraisals, and warranties in an encrypted off-site location.",
  },
  {
    id: "network",
    q: "Do you know which professionals (attorney, engineer, adjuster) you would call after a major loss?",
    weight: 15,
    area: "Professional support network",
    step: "Pre-qualify a trusted network of legal, engineering, and claims professionals before you need them.",
  },
];

export const levelFor = (score) => {
  if (score >= 80) return { label: "Well Prepared", tone: "text-emerald-400", note: "Strong foundation. A professional review can confirm nothing is being overlooked." };
  if (score >= 50) return { label: "Moderate Exposure", tone: "text-amber-400", note: "Meaningful gaps exist that could weaken your position after a loss." };
  return { label: "High Exposure", tone: "text-[#ff4d55]", note: "Significant gaps. Addressing these before a loss is strongly recommended." };
};

export const scoreAnswers = (answers) => {
  const score = QUESTIONS.reduce((s, q) => s + (answers[q.id] ? q.weight : 0), 0);
  const gaps = QUESTIONS.filter((q) => answers[q.id] === false);
  return { score, level: levelFor(score), gaps };
};

const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

export const openSnapshot = (name, result) => {
  const date = new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
  const gaps = result.gaps.length
    ? result.gaps.map((g) => `<li><b>${esc(g.area)}</b><br/><span>${esc(g.step)}</span></li>`).join("")
    : "<li><b>No major gaps identified</b><br/><span>Consider a professional review to validate your preparedness.</span></li>";
  const html = `<!doctype html><html><head><meta charset="utf-8"/><title>Risk Snapshot — Before The Risk</title>
<style>body{font-family:Helvetica,Arial,sans-serif;color:#111;max-width:720px;margin:40px auto;padding:0 24px}
h1{font-size:26px;margin:0}.k{color:#a2020b;letter-spacing:.2em;font-size:11px;text-transform:uppercase}
.score{font-size:64px;font-weight:800;margin:16px 0 0}.lvl{font-size:18px;font-weight:700;color:#a2020b}
li{margin:0 0 14px}li span{color:#444;font-size:14px}hr{border:0;border-top:1px solid #ddd;margin:28px 0}
.f{font-size:11px;color:#777}</style></head><body>
<div class="k">Before The Risk · Risk Readiness Snapshot</div><h1>Prepared for ${esc(name)}</h1><div class="f">${date}</div>
<div class="score">${result.score}<span style="font-size:20px;color:#777"> / 100</span></div><div class="lvl">${esc(result.level.label)}</div>
<p>${esc(result.level.note)}</p><hr/><div class="k">Identified risk areas &amp; recommended next steps</div><ol>${gaps}</ol><hr/>
<p><b>Before the loss. Before the litigation. Before the risk.</b><br/>Schedule a confidential consultation: contact@beforetherisk.com</p>
<p class="f">This preliminary snapshot is educational and based solely on self-reported answers. It is not an inspection, appraisal, or legal advice.</p>
<script>window.onload=function(){window.print()}</script></body></html>`;
  const w = window.open("", "_blank");
  if (!w) return false;
  w.document.write(html);
  w.document.close();
  return true;
};
